var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"personal-setting"},[_c('div',{staticClass:"logout",on:{"click":_vm.logout}},[_c('span',[_vm._v("退出账号")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }